<template>
  <div>
    <h3>Sites</h3>
    <div class="main-div">
      <div v-if="mySites">
        This page contains site based on the following criteria:
        <ul>
          <li>Sites created by you</li>
          <li>Sites with opportunities created by you</li>
          <li>
            Sites with opportunities tied to an internship course that you are
            assigned to
          </li>
        </ul>
      </div>

      <b-input-group class="filter-group">
        <b-input-group-prepend is-text>
          <font-awesome-icon icon="search" />
        </b-input-group-prepend>
        <b-form-input
          v-model="filter"
          placeholder="Type to Search"
        ></b-form-input>
        <b-input-group-append>
          <b-button @click="filter = null">Clear</b-button>
        </b-input-group-append>

        <b-button
          v-if="canAddSite()"
          class="new-site-button"
          :to="{ name: 'siteAdd' }"
          ><font-awesome-icon icon="plus" /> New Site</b-button
        >
      </b-input-group>

      <div>
        <a :href="csvUrl">Download CSV</a>
      </div>

      <b-table
        striped
        hover
        :items="sites"
        :fields="fields"
        :sort-by="sortBy"
        :per-page="perPage"
        :current-page="currentPage"
        :filter="filter"
        @filtered="onFiltered"
        responsive
      >
        <template slot="address" slot-scope="data">
          {{ data.item.streetAddress }}, {{ data.item.city }}
          {{ data.item.state }} {{ data.item.zip }}
        </template>
        <template slot="contactName" slot-scope="data">
          {{
            data.item.siteContacts[0] ? data.item.siteContacts[0].firstName : ""
          }}
          {{
            data.item.siteContacts[0] ? data.item.siteContacts[0].lastName : ""
          }}
        </template>
        <template slot="contactPhoneNumber" slot-scope="data">
          {{
            data.item.siteContacts[0]
              ? data.item.siteContacts[0].phoneNumber
              : ""
          }}
        </template>
        <template slot="contactEmailAddress" slot-scope="data">
          {{ data.item.siteContacts[0] ? data.item.siteContacts[0].email : "" }}
        </template>
        <template slot="siteContractrequirement.name" slot-scope="data">
          {{
            data.item.siteContractrequirement
              ? data.item.siteContractrequirement.name
              : ""
          }}
        </template>
        <template slot="contract" slot-scope="data">
          {{
            data.item.contractSites && data.item.contractSites.length
              ? "Yes"
              : "No"
          }}
        </template>
        <template slot="details" slot-scope="data">
          <router-link
            :to="{ name: 'site', params: { siteId: data.item.siteId } }"
            >Details</router-link
          >
        </template>
        <template slot="create">
          <router-link :to="{ name: 'contractList' }"
            >Create Contract</router-link
          >
        </template>
      </b-table>
      <b-pagination
        :total-rows="totalRows"
        v-model="currentPage"
        :per-page="perPage"
        align="right"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars

export default {
  data() {
    return {
      fields: [
        { key: "name", sortable: true },
        { key: "address" },
        { key: "website" },
        { key: "phone" },
        { key: "fax" },
        { key: "siteContractrequirement.name", sortable: true },
        { key: "contract" },
        { key: "details", label: "" },
      ],
      sortBy: "name",
      currentPage: 1,
      perPage: 20,
      filter: null,
      totalRows: 0,
    };
  },

  props: {
    sites: {
      type: Array,
      required: true,
    },

    noContract: {
      type: Boolean,
    },

    requireContract: {
      type: Boolean,
    },

    mySites: {
      type: Boolean,
    },
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    csvUrl() {
      return process.env.VUE_APP_BASE_URI + "/api/sitereports/sitescsv";
    },
  },

  watch: {
    sites: function () {
      this.totalRows = this.sites.length;
    },
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    canAddSite: function () {
      // TODO: Replace with role-checks mixin, check for site manager role
      return _.find(this.user.userRoles, function (userRole) {
        return (
          userRole === "Placements.Admin" ||
          userRole === "Placements.ContractManager" ||
          userRole === "Placements.Advisor"
        );
      });
    },
  },

  created() {
    // fields are different depending on user roles
    // also,  page for My Sites has fewer fields
    if (!this.canAddSite() || this.mySites) {
      _.remove(this.fields, function (field) {
        return field.key === "contractRequired" || field.key === "contract";
      });
    }

    // page for sites with no contracts or that require contracts also have different fields
    if (this.noContract || this.requireContract) {
      _.remove(this.fields, function (field) {
        return (
          field.key === "website" ||
          field.key === "phone" ||
          field.key === "fax" ||
          field.key === "contract"
        );
      });
    }

    // page for sites that require contracts have extra columns
    if (this.requireContract) {
      this.fields.splice(2, 0, { key: "contactName" });
      this.fields.splice(3, 0, { key: "contactPhoneNumber" });
      this.fields.splice(4, 0, { key: "contactEmailAddress" });
      this.fields.push({ key: "create", label: "" });
    }
  },
};
</script>

<style scoped>
.filter-group {
  margin: 10px 0 15px 0;
  max-width: 600px;
}

.new-site-button {
  margin-left: 10px;
}
</style>
